import React, {useEffect} from 'react';
import UserParlaysContainer from "../UserParlaysContainer/UserParlaysContainer";
import './MyOngoing.style.scss';
import {useDispatch, useSelector} from "react-redux";
import {selectUserParlaysOnGoing} from "../../stores/pickX/pickX.selectors";
import pickXApi, {useGetActiveUserParlaysQuery} from "../../stores/pickX/pickX.api";
import {setSelectedParlayId} from "../../stores/pickX/pickX.slice";
import {useLocation} from "react-router-dom";

const MyOngoing = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    const ongoingUserParlays = useSelector(selectUserParlaysOnGoing);
    const {isLoading} = useGetActiveUserParlaysQuery();
    const queryParams = new URLSearchParams(location.search);
    const parlayId = queryParams.get("parlayId");

    useEffect(() => {
        if(parlayId) dispatch(setSelectedParlayId(parlayId));
        return () => {
            dispatch(setSelectedParlayId(null));
        };
    }, [parlayId]);

    return (
        <div className="MyOngoing">
            <UserParlaysContainer userParlays={ongoingUserParlays}/>
        </div>
    );
};

export default MyOngoing;